import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-add-edit-competitor',
    templateUrl: './add-edit-competitor.component.html',
    styleUrls: ['./add-edit-competitor.component.scss'],
    standalone: false
})
export class AddEditCompetitorComponent implements OnInit {
  competitor: any;
  addCompetitorForm: FormGroup;
  type: any;
  productId: any;
  user: User;

  constructor(public dialogRef: MatDialogRef<AddEditCompetitorComponent>,
              private dataService: DataService,
              private utils: UtilsService,
              private authService: AuthService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.type = data.type;
                this.competitor = this.data.competitor;
                this.productId = this.data.productId;
                this.user = this.authService.getUserData();
              }

  ngOnInit(): void {
    this.addCompetitorForm = new FormGroup({
      modal_name: new FormControl(this.competitor ? this.competitor.modelName : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      manufacturer_name: new FormControl(this.competitor ? this.competitor.competitorName : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
  }

  closeDialog() {
    if (this.addCompetitorForm.dirty && this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit() {
    if (this.addCompetitorForm.valid) {
      if (this.type === 'Edit') {
        const payload = {
          CompetitorId: this.competitor.id,
          ModelName: this.addCompetitorForm.get('modal_name').value,
          CompetitorName: this.addCompetitorForm.get('manufacturer_name').value,
          ProductId: parseInt(this.productId.toString(), 10)
        };
        this.dataService.put('product/competitor/UpdateProductCompetitor', payload).then((data) => {
          if (data.statusCode === 200) {
            this.dialogRef.close(payload);
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Competitor information updated successfully',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      } else if (this.type === 'Add') {
        const payload = {
          ModelName: this.addCompetitorForm.get('modal_name').value,
          CompetitorName: this.addCompetitorForm.get('manufacturer_name').value,
          ProductId: parseInt(this.productId.toString(), 10)
        };
        this.dataService.post('product/competitor/CreateProductCompetitor', payload).then((data) => {
          if (data.statusCode === 200) {
            this.dialogRef.close(data.data);
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Competitor added successfully',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      }
    } else {
      this.addCompetitorForm.markAllAsTouched();
    }

  }

}
